// extracted by mini-css-extract-plugin
export default {"hideLinks":"(max-width: 64rem)","userWrapper":"SiCY8RfF","user":"MymzWWxH","userName":"aG62DceM","avatarBox":"lLi_bYV5 ICfy6PCi","spinner":"blbAuZd_ hiTP2iR5"};